import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import I18n from "i18n-js";
import { parentsFirebase } from "app/Auth";
import Constants from "common/constant";
import { btnDelay, usePlaySound } from "common/utils";
import { Footer } from "features/home";
import { updateLastSignInTime } from "features/user/api";
import { useSignUp } from "./hook";
import { BackBtn } from "./BackBtn";
import { MobileInput } from "./AuthStyles";

export const EmailLoginScreen = () => {
  useSignUp();
  const navigate = useNavigate();
  const playSound = usePlaySound();
  const auth = getAuth(parentsFirebase);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    if (!password) {
      setError(I18n.t("MSG_SIGN_PASSWORD_REQUIRED"));
      playSound();
      return;
    }

    setIsLoading(true);
    setError("");
    playSound();

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      updateLastSignInTime();
      navigate("/");
    } catch (err) {
      setError(I18n.t("MSG_SIGN_LOGIN_FAILED"));
      playSound();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-col-el flex-center relative w-full h-full">
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/new_bg_puzzle.png`}
        className="absolute inset-0 object-cover w-full h-full z-[-1]"
      />
      <BackBtn />
      <div className="flex-col-el flex-center w-full h-full max-w-md mx-auto">
        <div className="flex-col-el flex-center p-6 w-full">
          <div className="flex-col-el flex-center">
            <p className="text-body text-3xl !mb-6 text-center text-textcolor-black">
              {I18n.t("MSG_SIGN_IN_WITH_MAIL")}
            </p>
          </div>

          <div className="flex-col-el flex-center w-full max-w-sm gap-4">
            <MobileInput
              type="email"
              value={email}
              onChange={(e) => {
                setError("");
                setEmail(e.target.value);
              }}
              placeholder={I18n.t("MSG_SIGN_USER_MAIL")}
              label={I18n.t("MSG_SIGN_USER_MAIL")}
              disabled={isLoading}
              className={error && !email ? "!border-red-500 !bg-red-50" : ""}
            />

            <MobileInput
              type="password"
              value={password}
              onChange={(e) => {
                setError("");
                setPassword(e.target.value);
              }}
              placeholder={I18n.t("MSG_SIGN_USER_PASSWORD")}
              label={I18n.t("MSG_SIGN_USER_PASSWORD")}
              disabled={isLoading}
              className={error && !password ? "!border-red-500 !bg-red-50" : ""}
            />

            {error && (
              <p className="text-body text-sm text-red-500 text-center">
                {error}
              </p>
            )}

            <div className="flex-col-el flex-center w-full max-w-sm gap-4 upsilon">
              <button
                className="btn btn-primary w-[375px] h-[40px]"
                onClick={handleLogin}
              >
                <p className="text-body text-base">
                  {I18n.t("MSG_SIGN_IN_BTN")}
                </p>
              </button>
            </div>

            <div className="flex-col-el landscape:flex-row landscape:justify-center w-full gap-4 landscape:gap-8">
              {/* パスワードを忘れた場合のリンク */}
              <div className="upsilon flex justify-center">
                <button
                  className="btn btn-primary-outlined"
                  onClick={() => {
                    btnDelay(() => {
                      playSound();
                      navigate("/auth/password-reset");
                    });
                  }}
                >
                  <p className="text-body text-sm">
                    {I18n.t("MSG_SIGN_IN_FORGOT_PASSWORD")}
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
